// dependencies
import React from "react";

import { faXmark } from "@fortawesome/pro-regular-svg-icons";

//components
import IconButton from "../../IconButton";
// styles
import css from "./CloseButton.module.scss";

interface CloseButtonProps {
	className?: string;
	onClick: () => void;
	disabled?: boolean;
	testId?: string;
}

/**
 *
 * @param props @deprecated Use the ButtonIcon component from the py-components package instead
 * @returns
 */
const CloseButton = (props: CloseButtonProps) => {
	const { className, onClick, disabled, testId } = props;

	return (
		<IconButton
			onClick={onClick}
			icon={faXmark}
			className={`${!disabled ? css.closeButton : ""} ${className}`}
			disabled={disabled}
			testId={testId}
			aria-label="Close"
		/>
	);
};

/** @deprecated Use the ButtonIcon component from the py-components package instead */
export default CloseButton;
